import { render, staticRenderFns } from "./NHSOAnnouceCard.vue?vue&type=template&id=c186a18a"
import script from "./NHSOAnnouceCard.vue?vue&type=script&lang=js"
export * from "./NHSOAnnouceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports